/**
 * The optional store logo of «Negocio» (plan §4.2, D10): which files the
 * owner may pick and what is uploaded. The image is resized in the browser to
 * at most 1024 px; a PNG stays PNG (transparency), anything else becomes a
 * JPEG q0.9.
 */

export const LOGO_MAX_EDGE = 1024;
export const LOGO_JPEG_QUALITY = 0.9;
/** The file picker's `accept`. */
export const LOGO_ACCEPT = 'image/png,image/jpeg,image/webp';

export type TLogoOutputType = 'image/png' | 'image/jpeg';

interface ILogoFileInfo {
  name: string;
  type: string;
}

const ACCEPTED_TYPES: readonly string[] = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/webp',
];
const ACCEPTED_EXTENSION = /\.(png|jpe?g|webp)$/i;
const PNG_EXTENSION = /\.png$/i;

/** PNG, JPEG or WebP: by MIME type, or by extension when the browser reports none. */
export function isAcceptedLogoFile(file: ILogoFileInfo): boolean {
  const type = file.type.trim().toLowerCase();
  if (type) return ACCEPTED_TYPES.includes(type);
  return ACCEPTED_EXTENSION.test(file.name);
}

/** PNG stays PNG; JPEG and WebP are uploaded as JPEG. */
export function logoOutputType(file: ILogoFileInfo): TLogoOutputType {
  const type = file.type.trim().toLowerCase();
  const png = type ? type === 'image/png' : PNG_EXTENSION.test(file.name);
  return png ? 'image/png' : 'image/jpeg';
}

/**
 * The upload's file name from the encoded blob's type, always `logo.png` or
 * `logo.jpg`: `/files/upload` checks the original name's extension (`.webp`
 * or `.HEIC` would be rejected) and the stored key takes its extension from it.
 */
export function logoUploadName(blobType: string): string {
  return blobType === 'image/png' ? 'logo.png' : 'logo.jpg';
}
